import { Navigate, useLocation, useParams } from 'react-router-dom';
import { firmIntelligenceUrl } from 'common/config/urls';
import {
  INTELLIGENCE_DEFAULT_SECONDARY_NAVIGATION_SLUG,
  INTELLIGENCE_DEFAULT_TERTIARY_NAVIGATION_SLUG,
} from './intelligenceNavigation.constants';

const FirmSummaryLegacyRedirect = () => {
  const { search } = useLocation();
  const { firmSlugParam } = useParams<{ firmSlugParam: string }>();
  const target = `${firmIntelligenceUrl(firmSlugParam as string)}/${INTELLIGENCE_DEFAULT_SECONDARY_NAVIGATION_SLUG}/${INTELLIGENCE_DEFAULT_TERTIARY_NAVIGATION_SLUG}${search}`;
  return <Navigate replace to={target} />;
};

export default FirmSummaryLegacyRedirect;
